import api from '../..'

const duplicateCourseLesson = (lesson: any) => {
  return api.post('administration/duplicateds', lesson)
}
export default duplicateCourseLesson
